import css from 'styled-jsx/css';

const styles = css.global`#renegociacao25-emp-confira {
  padding: 62px 0 40px;
  position: relative;
}

#renegociacao25-emp-confira .confira-titulo {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 100%;
  max-width: 50%;
  height: 260px;
  word-break: break-word;
}

#renegociacao25-emp-confira .confira-iphone {
  position: absolute;
  top: 60px;
  right: 0;
}

#renegociacao25-emp-confira .confira-passos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#renegociacao25-emp-confira .confira-passo {
  display: flex;
  align-items: center;
  gap: 8px;
}

#renegociacao25-emp-confira .confira-passo-number {
  color: #C00;
  font-family: "SantanderText";
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
}

#renegociacao25-emp-confira .confira-passo-texto {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}

#renegociacao25-emp-confira .confira-btn {
  width: 100%;
  max-width: 272px;
  height: 48px;
  margin: 24px auto 0;
}

@media (min-width: 992px) {
  #renegociacao25-emp-confira {
    padding: 64px 0 0;
  }

  #renegociacao25-emp-confira .ctn-home-24 {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  #renegociacao25-emp-confira .confira-titulo {
    font-size: 40px;
    line-height: 60px;
    width: 100%;
    max-width: 572px;
    height: auto;
  }

  #renegociacao25-emp-confira .confira-passos {
    margin-top: 26px;
    gap: 26px;
  }

  #renegociacao25-emp-confira .confira-passo {
    align-items: baseline;
  }
  
  #renegociacao25-emp-confira .confira-passo-texto {
    font-size: 20px;
  }
  
  #renegociacao25-emp-confira .confira-btn {
    margin: 32px 0 0;
  }

  #renegociacao25-emp-confira .confira-iphone-desk {
    margin-bottom: -4px;
  }
}`;

export default styles;